import { Injectable } from '@angular/core';

import { BaseService } from './base.service';

@Injectable()
export class SyncService {
	path = '/sync';

	constructor(private baseService: BaseService) {}

	getInstituteDepartments() {
		return this.baseService.get(this.path, '/institute_departaments', {});
	}

	getDepartments() {
		return this.baseService.get(this.path, '/department-list', {});
	}

	getInstitutes() {
		return this.baseService.get(this.path, '/institutes', {});
	}

  // deleteAny(id: number) {
  //   return this.baseService.delete(this.path, '/some-route/' + id);
  // }

	// postAny(params?) {
	// 	return this.baseService.post(this.path, '/some-route', params);
	// }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/sync.service.ts